var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappSel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 10.0342 1.7093 11.0195 2.08786 11.9158C2.29708 12.4111 2.4017 12.6588 2.41465 12.846C2.4276 13.0332 2.3725 13.2391 2.26231 13.6509L1.5 16.5L4.34908 15.7377C4.76091 15.6275 4.96683 15.5724 5.15401 15.5854C5.34121 15.5983 5.58889 15.7029 6.08426 15.9121C6.98059 16.2907 7.96582 16.5 9 16.5Z",
    stroke: "#2C8C53",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44111 9.28298L7.09432 8.4717C7.36962 8.12977 7.70993 7.81147 7.73663 7.35619C7.7433 7.2412 7.66245 6.72493 7.5006 5.69239C7.43701 5.28661 7.05815 5.25 6.72999 5.25C6.30236 5.25 6.08854 5.25 5.87621 5.34698C5.60786 5.46956 5.33234 5.81423 5.27188 6.103C5.22404 6.33147 5.25959 6.4889 5.33069 6.80377C5.63267 8.1411 6.34111 9.46185 7.43961 10.5604C8.53815 11.6589 9.8589 12.3674 11.1962 12.6693C11.5111 12.7404 11.6685 12.776 11.897 12.7281C12.1858 12.6677 12.5304 12.3922 12.653 12.1238C12.75 11.9114 12.75 11.6977 12.75 11.27C12.75 10.9418 12.7134 10.563 12.3076 10.4994C11.2751 10.3375 10.7588 10.2567 10.6438 10.2634C10.1885 10.2901 9.87023 10.6304 9.5283 10.9057L8.71702 11.5589",
    stroke: "#2C8C53",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappSel);
export default __webpack_public_path__ + "static/media/whatsapp_sel.a3878198a3f554f13c6efc3e6981f70b.svg";
export { ForwardRef as ReactComponent };